import { render, staticRenderFns } from "./Product4.vue?vue&type=template&id=379aa1b6&scoped=true&"
import script from "./Product4.vue?vue&type=script&lang=js&"
export * from "./Product4.vue?vue&type=script&lang=js&"
import style0 from "./Product4.vue?vue&type=style&index=0&id=379aa1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379aa1b6",
  null
  
)

export default component.exports